import { Popover } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { UseLogout } from "../../hooks/LogoutHooks";
import "./PiAccountPopover.css";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

interface PiAccountDialogProps {
  id: string;
  open: boolean;
  anchorEl: any;
  onClose: () => void;
  switchOrgCallback: () => void;
  settingsCallback: () => void;
}

/**
 * Three entries: settings, organisation, sign out.
 *
 * Settings lives here because this popover is the one piece of chrome that
 * renders on every surface (dashboard sidebar, both editor rails), so it is
 * what gives the dashboard an entry point at all. Language used to sit here
 * and moved into the settings dialog, where the rest of the preferences are.
 */
export default function PiAccountDialog(props: PiAccountDialogProps) {
  const { t } = useTranslation();
  const { onLogout } = UseLogout();

  // TODO: change org callback
  function ChangeOrganizationClicked() {
    props.switchOrgCallback();
  }
  function SettingsClicked() {
    props.onClose();
    props.settingsCallback();
  }
  function logoutClicked() {
    onLogout();
  }

  return (
    <>
      <Popover
        id={props.id}
        open={props.open}
        onClose={props.onClose}
        anchorEl={props.anchorEl}
        anchorOrigin={{
          vertical: -128,
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
            padding: "6px",
            minWidth: "220px",
            backgroundColor: "var(--pi-surface)",
          },
        }}
      >
        <div
          className="pi-accountpopover-root flex flex-col"
          data-testid="pi-accountpopover-root"
        >
          <button
            data-testid="account-menu-settings"
            onClick={SettingsClicked}
            className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-creator-primary-background rounded-md transition-colors cursor-pointer outline-none text-left"
          >
            <SettingsOutlinedIcon
              sx={{ fontSize: 20 }}
              className="text-creator-primary"
            />
            <span className="text-[14px] font-medium text-creator-text-sub font-poppins">
              {t("settings")}
            </span>
          </button>
          <button
            data-testid="account-menu-switch-org"
            onClick={ChangeOrganizationClicked}
            className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-creator-primary-background rounded-md transition-colors cursor-pointer outline-none text-left"
          >
            <CorporateFareOutlinedIcon
              sx={{ fontSize: 20 }}
              className="text-creator-primary"
            />
            <span className="text-[14px] font-medium text-creator-text-sub font-poppins">
              {t("switchOrganization")}
            </span>
          </button>
          <button
            data-testid="account-menu-logout"
            onClick={logoutClicked}
            className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-creator-primary-background rounded-md transition-colors cursor-pointer outline-none text-left"
          >
            <LogoutOutlinedIcon
              sx={{ fontSize: 20 }}
              className="text-creator-error"
            />
            <span className="text-[14px] font-medium text-creator-error font-poppins">
              {t("logout")}
            </span>
          </button>
        </div>
      </Popover>
    </>
  );
}
